<template>
  <el-dialog
    :title="modalType == 'add' ? '添加产品' : '编辑产品'"
    :visible.sync="visible"
    width="900px"
    :close-on-click-modal="false"
    @closed="clearForm"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="120px"
      class="modal-form"
    >
      <el-form-item prop="afid" label="唯一标识：">
        <el-input
          type="text"
          v-model.trim="ruleForm.afid"
          autocomplete="off"
          :disabled="modalType == 'add' ? false : true"
          @change="handleAFID"
          placeholder="请输入唯一标识"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品名称：" prop="appName">
        <el-input
          placeholder="请输入产品名称"
          v-model.trim="ruleForm.appName"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布市场：" prop="publishMarket">
        <el-select
          @change="handleAFID"
          style="width: 100%"
          v-model="ruleForm.publishMarket"
          placeholder="请选择发布市场"
        >
          <el-option
            v-for="item in publishMarketList"
            :key="item.publishMarket"
            :label="item.publishMarketName"
            :value="item.publishMarket"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台类型：" prop="publishPlatform">
        <el-select
          style="width: 100%"
          v-model="ruleForm.publishPlatform"
          placeholder="请选择平台类型"
        >
          <el-option
            v-for="item in marketTypeList"
            :key="item.refId"
            :label="item.name"
            :value="item.refId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道号：" v-if="isShowChannelNum" prop="originId">
        <el-input
          placeholder="输入渠道号，多个用逗号隔开"
          v-model.trim="ruleForm.channelNum"
        ></el-input>
      </el-form-item>
      <el-form-item label="DBTID：" prop="dbtId">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <el-input
            placeholder="请输入DBTID"
            v-model="ruleForm.dbtId"
          ></el-input>
          <el-tag
            type="danger"
            v-if="ruleForm.pubStatus && ruleForm.pubStatus == 1"
            size="mini"
            style="margin-left: 4px"
            >已下架
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item label="投放渠道：" prop="mediaSourceList">
        <el-select
          filterable
          multiple
          class="multiple-select"
          collapse-tags
          style="width: 100%"
          v-model="ruleForm.mediaSourceList"
          placeholder="请选择投放渠道"
        >
          <el-option
            v-for="item in mediaSourceOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原始ID：" prop="originId">
        <el-input
          placeholder="请输入原始ID"
          v-model.trim="ruleForm.originId"
        ></el-input>
      </el-form-item>
      <el-form-item label="投放名：" prop="launchName">
        <el-input
          placeholder="请输入投放名"
          v-model.trim="ruleForm.launchName"
        ></el-input>
      </el-form-item>

      <el-form-item label="主体类别：" prop="deliverySubType">
        <el-select
          style="width: 100%"
          v-model="ruleForm.deliverySubType"
          placeholder="请选择主体类别"
        >
          <el-option label="公司" :value="1"></el-option>
          <el-option label="个人" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="投放主体：" prop="deliverySubId">
        <el-select
          style="width: 100%"
          v-model="ruleForm.deliverySubId"
          placeholder="请选择投放主体"
        >
          <el-option
            v-for="item in deliverySubList"
            :key="item.id"
            :label="item.deliveryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变现形式：" prop="realizationType">
        <el-select
          style="width: 100%"
          v-model="ruleForm.realizationType"
          placeholder="请选择变现形式"
        >
          <el-option label="IAA" :value="1"></el-option>
          <el-option label="IAP" :value="2"></el-option>
          <el-option label="IAA+IAP" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="域名组：" prop="accountGroupCode">
        <el-select
          style="width: 100%"
          v-model="ruleForm.accountGroupCode"
          placeholder="请选择域名组"
        >
          <el-option
            v-for="item in accountGroupCodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="af账号ID：" prop="afAccount">
        <el-select
          style="width: 100%"
          v-model="ruleForm.afAccount"
          placeholder="请选择af账号ID"
        >
          <el-option
            v-for="item of afAccountList"
            :label="item.biKey"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="firebaseApiSecret" label="FirebaseApi：">
        <el-input
            type="text"
            v-model.trim="ruleForm.firebaseApiSecret"
            autocomplete="off"
            placeholder="FirebaseApi"
            maxlength="30"
        ></el-input>
      </el-form-item>
      <el-form-item prop="afDevKey" label="AF_Dev key：">
        <el-input
            type="text"
            v-model.trim="ruleForm.afDevKey"
            autocomplete="off"
            placeholder="请输入AF_Dev key"
        ></el-input>
      </el-form-item>
      <el-form-item label="引力appid：" prop="gravityAppId">
        <el-input
          placeholder="请输入引力appid"
          v-model.trim="ruleForm.gravityAppId"
        ></el-input>
      </el-form-item>
      <el-form-item label="引力appkey：" prop="gravityAppKey">
        <el-select
          style="width: 100%"
          v-model="ruleForm.gravityAppKey"
          placeholder="请选择引力appkey"
        >
          <el-option
            v-for="item of appKeyList"
            :label="item.paraName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="mark">
        <el-input
          type="textarea"
          placeholder="请输入备注"
          v-model.trim="ruleForm.mark"
          maxlength="100"
          show-word-limit
          :autosize="{ minRows: 3 }"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="推广状态："
        prop="popuStatus"
        style="margin-top: -30px"
      >
        <el-switch
          v-model="ruleForm.popuStatus"
          :active-value="true"
          :inactive-value="false"
        ></el-switch>
      </el-form-item>
      <el-form-item
        label="引力归因时间"
        prop="gravityStartDateList"
        style="width: 100%"
      >
        <div
          v-for="(timeItem, timeIndex) in ruleForm.gravityStartDate"
          :key="timeIndex"
          class="launch-time-wrap"
        >
          <el-date-picker
            placeholder="请选择日期"
            clearable
            style="width: 20%"
            value-format="yyyy-MM-dd"
            v-model="timeItem.time[0]"
            type="date"
          >
          </el-date-picker>
          <span> ~ </span>
          <el-date-picker
            clearable
            style="width: 20%"
            value-format="yyyy-MM-dd"
            v-model="timeItem.time[1]"
            type="date"
            placeholder="至今"
          >
          </el-date-picker>
          <i
            class="el-icon-delete"
            v-if="ruleForm.gravityStartDate.length > 1"
            @click="() => ruleForm.gravityStartDate.splice(timeIndex, 1)"
          ></i>
          <i
            class="el-icon-plus"
            v-if="timeIndex === 0"
            @click="() => ruleForm.gravityStartDate.push({ time: ['', ''] })"
          ></i>
          <span v-if="timeIndex === 0" style="font-size: 12px; margin-left: 5px"
            >（填写的时段外使用AF归因数据，不使用引力归因无需填写）</span
          >
        </div>
      </el-form-item>
      <!-- <el-form-item label="仅接受引力数据：" prop="isGravity" class="yl-data">
        <div class="flex" style="align-items: center; height: 40px">
          <el-switch
            v-model="ruleForm.isGravity"
            :active-value="1"
            :inactive-value="0"
            style="margin-right: 12px"
          ></el-switch>
          <div v-if="ruleForm.isGravity == 1" class="flex">
            <el-date-picker
              v-model="ruleForm.gravityStartDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="margin-left: 4px; color: #999">起</span>
          </div>
        </div>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        @click="saveForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  getTagPropertySelectList,
  getPublishMarketsList,
} from "@/api/property";
import { getGravitationTable } from "@/api/gravitation";
import {
  getmediaSourceFetch,
  getDbtIdByAfIdFetch,
  getParamSettingListFetch,
  getDeliverySubList,
  addProductTableItemFetch,
  updateProductTableItemFetch,
} from "@/api/api";
import Vue from "vue";
import moment from "moment";
export default {
  data() {
    return {
      ruleForm: {},
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      rules: {
        afid: [{ required: true, message: "请输入唯一标识", trigger: "blur" }],
        appName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        publishMarket: [
          { required: false, message: "请选择发布市场", trigger: "change" },
        ],
        publishPlatform: [
          { required: true, message: "请选择平台类型", trigger: "change" },
        ],
        accountGroupCode: [
          { required: true, message: "请选择域名组", trigger: "change" },
        ],
        dbtId: [{ required: false, message: "请输入DBTID", trigger: "change" }],
        // 引力归因时间
        gravityStartDateList: [
          {
            validator: (rule, value, callback) => {
              const flagResult = this.isValidTimeRange(
                this.ruleForm.gravityStartDate
              );
              if (!flagResult) {
                callback(
                  new Error(
                    "起始时间未填写或选择的引力归因区间存在交集，请仔细检查并调整"
                  )
                );
              }

              callback();
            },

            trigger: ["change"],
          },
        ],
      },
      modalType: "",
      visible: false,
      publishMarketList: [],
      marketTypeList: [],
      mediaSourceOptions: [],
      afAccountList: [],
      btnLoading: false,
      deliverySubList: [],
      // 引力appkey列表
      appKeyList: [],
    };
  },
  props: {
    addormodify: String,
  },
  mounted() {},
  computed: {
    isShowChannelNum() {
      let flag = false;
      if (this.ruleForm.publishPlatform && this.marketTypeList.length > 0) {
        const findObj = this.marketTypeList.find(
          (item) => item.refId == this.ruleForm.publishPlatform
        );
        if (
          findObj &&
          ["小游戏 【国内】", "微小【国内】"].includes(findObj.name)
        ) {
          flag = true;
        }
      }
      return flag;
    },
  },
  methods: {
    getGravitationList() {
      getGravitationTable().then((res) => {
        if (res.code === "0000") {
          this.appKeyList = res.data;
        }
      });
    },
    async showModal(type, data) {
      await this.initSelect();
      this.modalType = type;
      if (type == "add") {
        this.ruleForm = {
          afid: "",
          afDevKey: "",
          firebaseApiSecret:"",
          appName: "",
          publishMarket: "",
          publishPlatform: "",
          dbtId: "",
          mediaSourceList: [],
          originId: "",
          channelNum: "",
          launchName: "",
          deliverySubType: "",
          deliverySubId: "",
          realizationType: 1,
          afAccount: null,
          mark: "",
          popuStatus: false,
          // 引力appid
          gravityAppId: "",
          // 引力appkey
          gravityAppKey: "",
          isGravity: 0,
          pubStatus: "",
          // 引力归因时间
          gravityStartDate: [
            {
              time: ["", ""],
            },
          ],
        };
      } else {
        this.ruleForm = {
          ...data,
          popuStatus: data.popuStatus == 1 ? true : false,
          id: data.id,
        };
      }
      this.visible = true;
    },
    initSelect() {
      getTagPropertySelectList({ type: 10 }).then((res) => {
        this.marketTypeList = res.data;
      });
      getPublishMarketsList().then((res) => {
        this.publishMarketList = res.data;
      });
      getmediaSourceFetch().then((res) => {
        this.mediaSourceOptions = res.mediaList;
      });
      getParamSettingListFetch().then((res) => {
        if (res.code === "0000") {
          this.afAccountList = res.sysParas;
        }
      });
      // 获取引力appkey列表
      this.getGravitationList();
      getDeliverySubList({
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        this.deliverySubList = res.data.list;
        const findDbtId = this.deliverySubList.find(
          (item) => item.deliveryName == "多比特"
        )?.id;
        if (this.modalType == "add") {
          Vue.set(this.ruleForm, "deliverySubId", findDbtId);
        }
      });
    },
    cancelForm() {
      this.visible = false;
      this.$emit("closeDialogForm");
    },
    handleAFID() {
      const { afid: afId, publishMarket } = this.ruleForm;
      if (!afId) return;
      getDbtIdByAfIdFetch({ afId, publishMarket }).then((res) => {
        if (res.code == "0000") {
          const {
            dbtId,
            appName,
            publishPlatform,
            mediaSourceList,
            pubStatus,
            publishMarket,
            accountGroupCode,
          } = res.data;
          Vue.set(this.ruleForm, "dbtId", dbtId);
          Vue.set(this.ruleForm, "appName", appName);
          Vue.set(this.ruleForm, "publishPlatform", publishPlatform);
          Vue.set(this.ruleForm, "publishMarket", publishMarket);
          Vue.set(this.ruleForm, "mediaSourceList", mediaSourceList);
          Vue.set(this.ruleForm, "pubStatus", pubStatus);
          Vue.set(this.ruleForm, "accountGroupCode", accountGroupCode);
        }
      });
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          // const { isGravity, gravityStartDate } = this.ruleForm;
          if (this.modalType == "add") {
            addProductTableItemFetch({
              ...this.ruleForm,
              // gravityStartDate: isGravity == 0 ? "" : gravityStartDate,
              popuStatus: this.ruleForm.popuStatus ? 1 : 0,
              // 引力归因时间
              gravityStartDate: this.ruleForm.gravityStartDate
                .map((i) => {
                  if (i.time[1]) {
                    return i.time.join("~");
                  } else {
                    return i.time[0];
                  }
                })
                .join(","),
            }).then((res) => {
              if (res.code == "0000") {
                this.$message.success("新增成功");
                this.visible = false;
                this.$emit("closeDialogForm");
              }
              this.btnLoading = false;
            });
          } else {
            updateProductTableItemFetch({
              ...this.ruleForm,
              // gravityStartDate: isGravity == 0 ? "" : gravityStartDate,
              popuStatus: this.ruleForm.popuStatus ? 1 : 0,
              // 引力归因时间
              gravityStartDate: this.ruleForm.gravityStartDate
                .map((i) => {
                  if (i.time[1]) {
                    return i.time.join("~");
                  } else {
                    return i.time[0];
                  }
                })
                .join(","),
            }).then((res) => {
              if (res.code == "0000") {
                this.$message.success("编辑成功");
                this.visible = false;
                this.$emit("closeDialogForm");
              }
              this.btnLoading = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.$refs.ruleForm.clearValidate();
    },
    // 投放时间范围交叉校验
    isValidTimeRange(timeRange) {
      const emptyList = timeRange.filter((i) => !i.time[0] && !i.time[1]);

      if (emptyList.length === timeRange.length) {
        return true;
      }

      // 获取当前时间
      const now = moment();

      // 遍历数组，校验时间范围
      for (let i = 0; i < timeRange.length; i++) {
        let { time } = timeRange[i];
        let startTime = moment(time[0]);
        let endTime = time[1] ? moment(time[1]) : now;

        // 起始时间必填
        if (!startTime) {
          return false;
        }

        // 格式化时间
        const formatTime = (date) => date.format("YYYY-MM-DD");

        startTime = formatTime(startTime);
        endTime = formatTime(endTime);

        // 校验结束时间是否早于起始时间
        if (endTime < startTime) {
          return false;
        }

        // 校验当前时间项与其他时间项是否存在交叉
        for (let j = 0; j < timeRange.length; j++) {
          if (i !== j) {
            const { time: otherTime } = timeRange[j];
            let otherStartTime = moment(otherTime[0]);
            let otherEndTime = otherTime[1] ? moment(otherTime[1]) : now;

            otherStartTime = formatTime(otherStartTime);
            otherEndTime = formatTime(otherEndTime);

            if (startTime <= otherEndTime && endTime >= otherStartTime) {
              return false;
            }
          }
        }
      }

      return true;
    },
  },
};
</script>

<style scoped lang="less">
.modal-form {
  display: flex;
  flex-wrap: wrap;
  .launch-time-wrap {
    margin-bottom: 8px;
    .el-icon-delete {
      color: #f56c6c;
      margin-left: 8px;
      cursor: pointer;
      font-size: 16px;
    }
    .el-icon-plus {
      color: #409eff;
      margin-left: 8px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  /deep/ .el-form-item {
    width: 50%;
  }
  .is-required {
    /deep/ .el-form-item__label::before {
      content: "*";
      display: inline-block;
      color: red;
      margin-right: 4px;
    }
  }
  /deep/ .el-input__count {
    line-height: 20px;
    bottom: 1px;
  }
  .multiple-select {
    /deep/ .el-tag.el-tag--info:first-child {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .yl-data {
    /deep/ .el-form-item__label {
      width: 130px !important;
    }
  }
}
</style>
